import { css } from '@emotion/react';
import styled from '@emotion/styled';

export const EmojiContainer = styled.div`
  display: flex;
  position: relative;
  flex-wrap: wrap;
  align-content: center;
  gap: 4px;
`;

export const EmojiWrapper = styled.button<{ active?: boolean }>`
  ${({ theme, active }) => css`
    display: flex;
    position: relative;
    align-items: center;
    height: 32px;
    padding: 8px;
    border-radius: 16px;
    background: ${active
      ? theme.themeColor.main_dark
      : theme.backgroundColor.bg_dark_2};
    gap: 8px;

    img {
      width: 16px;
      height: 16px;
    }
  `}
`;

export const EmojiOptionWrapper = styled(EmojiWrapper)`
  width: 56px;
`;

export const SelectModalContainer = styled.div<{ topHeight?: number }>`
  ${({ theme, topHeight }) => css`
    display: flex;
    position: absolute;
    top: calc(${topHeight ? `${topHeight}px` : '32px'} + 6px);
    align-items: center;
    justify-content: flex-start;
    width: auto;
    padding: 8px;
    border-radius: 16px;
    background: ${theme.backgroundColor.bg_dark_2};
    box-shadow: 0px 0px 16px 0px rgba(0, 0, 0, 0.5);
    color: white;
    gap: 8px;
  `}
`;

export const SelectOption = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  width: 44px;
  padding: 4px 0;

  img {
    width: 16px;
    height: 16px;
  }
`;
